<div
  class="info-tooltip"
  [ngClass]="'info-tooltip--' + currentPlacement"
  [style.--tooltip-shift-x.px]="horizontalShift"
  [style.--tooltip-shift-y.px]="verticalShift"
>
  <button
    type="button"
    class="info-tooltip__trigger"
    [attr.aria-label]="ariaLabelKey ? (ariaLabelKey | transloco) : (textKey | transloco: params)"
    [attr.aria-describedby]="tooltipId"
    (focus)="show()"
    (blur)="hide()"
    (mouseenter)="show()"
    (mouseleave)="hide()"
    (click)="toggle($event)"
  >
    <span aria-hidden="true">?</span>
  </button>

  @if (isVisible) {
    <div
      #bubbleElement
      class="info-tooltip__bubble"
      role="tooltip"
      [id]="tooltipId"
    >
      {{ textKey | transloco: params }}
    </div>
  }
</div>
